export default "__VITE_ASSET__CuqAVlgM__"